<template>
  <a-input-password
      v-show="info.status === 'edit'"
      v-model:value="data[propName]"
      :placeholder="
      data[propName + 'Set'] ? '修改' + info.title : '请填写' + info.title
    "
  />
  <div v-show="info.status === 'show'" class="view">
    <password-table :data="data" v-bind="$props"/>
  </div>
</template>


<script lang="ts" setup>
import {defineProps} from 'vue';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer"
import {ScForm} from "@/models/ScForm";
import PasswordTable from "./PasswordTable.vue";
import {PasswordFieldType} from "@/components/business/crud/interface/FieldType";

const props = defineProps<{
  propName: string;
  widget: PasswordFieldType;
  info: WidgetInfo;
}>();

const data = ScForm.useFormData();
</script>

<style lang="scss" scoped>
.view {
  height: 100%;
  padding-left: 12px;
}
</style>
